import { useEffect } from "react";

const useScript = (url, body) => {
  useEffect(() => {
    const script = document.createElement("script");
    if (url) {
      script.src = url;
      script.async = true;
    } else {
      script.innerHTML = body;
    }

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, body]);
};

export default useScript;
